import { ActionIcon, Drawer, Tabs } from "@mantine/core";
import Link                         from "next/link";
import { useRouter }                from "next/router";
import { useState }                 from "react";

import { useGetLoggedIn }   from "_common/hooks/auth";
import { useSetLoginPopup } from "_common/hooks/global";
import { PrimaryButton }    from "_components/atoms/button";
import Icon                 from "_components/atoms/icon";
import Image                from "_components/atoms/image";
import Typography           from "_components/atoms/typography";

import useStyles from "./styles";

export const zeroPad = ( num, places ) => String ( num ).padStart ( places, "0" );

function kFormatter ( num ) {
	return Math.abs ( num ) > 999 ? Math.sign ( num ) * ( ( Math.abs ( num ) / 1000 ).toFixed ( 1 ) ) + "k" : Math.sign ( num ) * Math.abs ( num );
}

const UserCard = ( { item, rank, selfCard } ) => {

	const { classes }   = useStyles ( { selfCard }, { name: "creatorLeaderboard" } );
	const isLoggedIn    = useGetLoggedIn ();
	const setLoginPopup = useSetLoginPopup ();

	if ( selfCard && !isLoggedIn )
		return (
			<div className = { classes.loginButtonContainer }>
				<PrimaryButton
					className = { classes.loginButton }
					fullWidth = { true }
					onClick = { () => setLoginPopup ( true ) }
					title = { "Login to view your Rank" }
				/>
			</div>
		);

	if ( !item )
		return null;

	return (
		<div
			className = { classes.itemCard }
		>
			<div className = { classes.itemLeft }>
				<div className = { classes.rank }>
					{
						typeof rank !== "number" ? (
							<Typography
								className = { classes.rank }
								title = { "-" }
							/>
						) :
							rank > 3 ?
								(
									<Typography
										className = { classes.rank }
										title = { `#${ zeroPad ( rank, 2 ) }` }
									/>
								)
								:
								rank === 1 ? (
									<Icon sameInBothTheme
										name = "fanRank1"
										size = { 24 }
									/>
								)
									: rank === 2 ? (
										<Icon sameInBothTheme
											name = "fanRank2"
											size = { 24 }
										/>
									)
										: (
											<Icon sameInBothTheme
												name = "fanRank3"
												size = { 24 }
											/>
										)
					}
				</div>

				<Link
					className = { classes.itemPhotoContainer }
					href = { `/profile/${ item?.userId }` }
				>
					{/* <div className = { classes.itemPhotoContainer }> */}
					<Image className = { classes.itemPhoto }
						src = { item.photo }
						type = "mdpi"
					/>

					{/* </div> */}

				</Link>

				<div className = { classes.itemDetails }>
					<Typography
						title = { item.name }
						weight = "500"
					/>
				</div>
			</div>

			<div className = { classes.itemRight }>
				<Typography
					className = { classes.donationText }
					size = "xs"
					ta = "end"
					title = { "Donation" }
				/>

				<div className = { classes.donationContainer }>
					<Icon sameInBothTheme
						name = "diamond"
						size = { 12 }
					/>

					<Typography
						className = { classes.donation }
						size = "sm"
						title = { kFormatter ( item.donation_recieved ) }
					/>

				</div>
			</div>

		</div>
	);
};
const LeaderboardContent = ( { data } ) => {
	const { classes } = useStyles ( {}, { name: "creatorLeaderboard" } );
	const topRankers  = data?.topRankers;

	return (
		<div className = { classes.innerContainer }>
			{/* {data?.banner?.url && (
				<div className = { classes.bannerContainer }>
					<Image
						className = { classes.topBanner }
						src = { data?.banner?.url }
						type = "xhdpi"
					/>

				</div>
			)} */}
			{data?.banner && (
				<div className = { classes.priorityBox }>
					<Image
						className = { classes.trophyImage }
						src = { "/icons/trophy.webp" }
					/>

					<div className = { classes.topContent }>
						<Typography
							color = "white"
							size = "sm"
							title = { data?.banner?.heading || "" }
							weight = "500"
						/>

						<Typography
							color = "white"
							mt = "0"
							size = "sm"
							title = { data?.banner?.subHeading || "" }
							weight = "500"
						/>

						<Typography
							color = "white"
							lh = "1.55"
							mt = "0.2rem"
							size = "2.4rem"
							title = { data?.banner?.amount ? `₹ ${ data?.banner?.amount }` : "" }
							weight = "bold"
						/>
					</div>
				</div>
			)}

			<div className = { classes.listContainer }>
				{topRankers?.map ( ( item, idx ) => {
					const rank = item?.rank;

					return (
						<UserCard
							key = { idx }
							item = { item }
							rank = { rank }
						/>
					);
				} )}

			</div>

		</div>
	);
};

const InfoDrawer = ( { opened, setOpened } ) => {
	const { classes } = useStyles ( {}, { name: "creatorLeaderboard" } );

	return (
		<Drawer
			classNames = { { content: classes.drawerContent } }
			onClose = { () => {
				setOpened ( false );
			} }
			opened = { opened }
			position = "bottom"
			withCloseButton = { false }
		>
			<div className = { classes.drawerHeader }>
				<Typography
					size = "lg"
					title = { "Information" }
					weight = "500"
				/>

				<Icon
					name = "cross"
					onClick = { () => setOpened ( false ) }
					size = { 24 }
				/>
			</div>

			<div className = { classes.drawerInner }>
				<ul className = { classes.infoList }>
					<li
						className = { classes.infoItem }
					>
						<Typography
							className = { classes.infoItem }
							size = "sm"
							title = {
								"Data will be refreshed every day"
							}
						/>
					</li>

					<li
						className = { classes.infoItem }
					>
						<Typography
							className = { classes.infoItem }
							size = "sm"
							title = {
								"Any fraudulent donations will directly lead to disqualification"
							}
						/>
					</li>

					<li
						className = { classes.infoItem }
					>
						<Typography
							className = { classes.infoItem }
							size = "sm"
							title = {
								"Winners will be contacted by the Team and Rewards will be disbursed within 1 week after the announcement"
							}
						/>
					</li>

					<li
						className = { classes.infoItem }
					>
						<Typography
							className = { classes.infoItem }
							size = "sm"
							title = { (
								<>
									For any query, please contact
									{" "}

									<a href = "mailto:shop@rooter.io?subject=Donation Leaderboard">shop@rooter.io</a>

									{" "}
									with subject : Donation Leaderboard
								</>
							) }
						/>
					</li>

				</ul>

				<PrimaryButton
					fullWidth
					onClick = { () => setOpened ( false ) }
					title = { "Okay" }
				/>
			</div>
		</Drawer>
	);

};
const Component = props => {
	const { classes }                             = useStyles ( {}, { name: "creatorLeaderboard" } );
	const [ infoModalOpened, setInfoModalOpened ] = useState ( false );
	const selfData                                = props?.leaderboardData?.userRank?.[0];
	const router                                  = useRouter ();

	const onClose = () => {
		if ( router.query.platform === "android" ) {
			window?.Android?.closeActivity ();
		} else if ( router.query.platform === "ios" ) {
			// Send a message with arguments to the native iOS code
			let dataToSend = {
				action: "closeActivity" // action is always name of the JS function
			};

			window?.webkit?.messageHandlers?.ios_handler?.postMessage ( JSON.stringify ( dataToSend ) );
		} else {
			router.push ( "/" );
		}
	};

	return (
		<div className = { classes.mainContainer }>
			<div className = { classes.container }>

				<InfoDrawer
					opened = { infoModalOpened }
					setOpened = { setInfoModalOpened }
				/>

				<div className = { classes.topHeader }>
					<ActionIcon classNames = { { root: classes.actionIcon } }>

						<Icon
							name = "cross"
							onClick = { onClose }
							size = { 30 }
						/>
					</ActionIcon>

					<Image
						className = { classes.dominationHeading }
						src = { "/images/donation-domination.webp" }
					/>

					<ActionIcon classNames = { { root: classes.actionIcon } }>

						<Icon
							sameInBothTheme
							name = "infoFilled"
							onClick = { () => setInfoModalOpened ( true ) }
							size = { 24 }
						/>
					</ActionIcon>
				</div>

				<Tabs
					classNames = { {
						root     : classes.tabsRoot,
						tab      : classes.tab,
						tabLabel : classes.tabLabel,
						tabsList : classes.tabsList,
						panel    : classes.panel
					} }
					defaultValue = "thisMonth"
				>
					<Tabs.List>
						<Tabs.Tab value = "thisMonth">This Month</Tabs.Tab>

					</Tabs.List>

					<Tabs.Panel value = "thisMonth">
						<LeaderboardContent data = { props?.leaderboardData } />

					</Tabs.Panel>

					<Tabs.Panel value = "lastMonth">
					</Tabs.Panel>
				</Tabs>

				<div className = { classes.selfCardContainer }>

					<UserCard
						item = { selfData }
						rank = { selfData?.rank }
						selfCard = { true }
					/>
				</div>

			</div>
		</div>
	);
};

export default Component;
